import React, { Suspense } from "react";
import Navbar from "@/components/Navbar";
import Mission from "@/components/sections/Mission";
import Footer from "@/components/sections/Footer";

const MissionPage = () => {
  console.log("[MissionPage] Rendering Mission page");
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow pt-28">
        <Suspense fallback={<div>Loading...</div>}>
          <Mission />
        </Suspense>
      </div>
      <Footer />
    </div>
  );
};

export default MissionPage;